import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { navigateToUrl } from '@frontend/auth';
import { getWeaveToken } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader, FormWrap, Layout } from '../../components';
import { hydraShellService } from '../../services';

export const Route = createFileRoute('/sign-out/callback')({
  component: SignOutCallbackRouteComponent,
});

function SignOutCallbackRouteComponent() {
  const { t } = useTranslation('SignIn');
  useEffect(() => {
    const weaveJWT = getWeaveToken() || ''; // if already authenticated then this will never be undefined
    hydraShellService
      .acceptLogoutFlow(weaveJWT)
      .then((res) => {
        if (!!res?.redirectTo) {
          navigateToUrl(res.redirectTo);
        } else {
          navigateToUrl('https://weaveworkforce.okta.com');
        }
      })
      .catch((err) => {
        navigateToUrl('https://weaveworkforce.okta.com', {
          reason: `error caught in sign-out callback`,
          error: err,
        });
      });
  }, []);

  return (
    <Layout background={'blue'}>
      <FormWrap>
        <ContentLoader message={t('Logging out...')} show />
      </FormWrap>
    </Layout>
  );
}
